export default __webpack_public_path__ + "static/deemo2-logo-037d10f3e31e1d09d3b47eb8a10e5f29.png";